import React, { useEffect } from "react"
import { Switch, Route } from "react-router-dom"
import AOS from "aos"
// import "aos/dist/aos.css";

// pages
import Home from "./pages/home"
import Audio from "./pages/audios"
import Video from "./pages/videos"
import Contact from "./pages/contact"
import SingThursday from "./pages/singThursday"
import Team from "./pages/team"
import Error from "./pages/error"

// components
import PlayAudio from "./components/playAudio"
import BackToTop from "./components/backToTop"
import Purchase from "./components/purchase"

// styles
import "./styles/styles.css"

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    })
    AOS.refresh()
  })

  return (
    <div className="App" id="App">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/beats" component={Audio} />
        <Route exact path="/releases" component={Video} />
        <Route exact path="/sing-thursday" component={SingThursday} />
        <Route exact path="/contact-us" component={Contact} />
        <Route exact path="/team" component={Team} />
        <Route component={Error} />
      </Switch>
      <BackToTop />
      <div className="audio-player-container">
        <PlayAudio />
      </div>
      <Purchase />
    </div>
  )
}

export default App
